<template>
	<th v-bind="attributes">
		<sort-click :supported="sortInfo && sortInfo.supported" :sort="sortType" @change="doSort"><span class="thitle"><sym-icon v-if="col.icon" :name="col.icon"></sym-icon><span
			v-if="hasTextTitle">{{ thitle }}</span></span></sort-click>
	</th>
</template>

<script setup lang="ts">
import {computed, type CSSProperties} from "vue";
import {Icon} from "anneca-symbols";
import {type CellBinding, cellStyle, ColSortInfo, ColSortState, injectCellAPI} from "./AgendaUtils";
import {escapeHtml} from "@t/util/SafeHtml";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {Column} from "@t/agenda/Columns.ts";
import SortClick from "@fd/containers/agenda/SortClick.vue";

const props = withDefaults(defineProps<{
	col: Column,
}>(), {  });

const api = injectCellAPI();
const colName = computed<string>(() => props.col.fullName || props.col.name);

const sortInfo = computed<ColSortInfo | null>(() => api.getSorting(colName.value));
const sortType = computed<ColSortState>(() => {
	const si:ColSortInfo|null = sortInfo.value;
	if (si == null) return "no";
	return si.state;
});
const isSorted = computed<boolean>(() => sortType.value !== "no");

const content = computed<string>(() => {
	let content = "";
	let icon = false;
	if (props.col.icon) {
		content += Icon.fi(props.col.icon);
		icon = true;
	}
	let titleText = typeof props.col.thitle === "string" ? props.col.thitle : props.col.title;
	if (titleText) {
		if (icon) content += " ";
		content += escapeHtml(titleText);
	}
	return content;
});

const hasTextTitle = computed<boolean>(() => props.col.thitle !== '');
const thitle = computed<string>(() => {
	if (props.col.thitle) return props.col.thitle;
	else if (props.col.title) return props.col.title;
	return props.col.name;
});

const attributes = computed<CellBinding>(() => {
	return { style: cellStyle(props.col) };
});

function doSort(type:ColSortState) {
    api.setSorting(colName.value, type);
}
</script>

<style>
.fd-sortable-th {
	cursor: pointer;
}
.fd-sortable-caret {
	margin-left: 4px;
	color: var(--active);
}
</style>
